import styles from './ChatPlaceholder.module.scss';
import AiIcon from 'assets/icons/ai-icon.svg?react';

type ChatPlaceholderProps = {
  mainText: string | React.ReactNode;
  helperText?: string | React.ReactNode;
};

export const ChatPlaceholder = (props: ChatPlaceholderProps) => {
  return (
    <div className={styles.placeholder}>
      <div className={styles.placeholderIcon}>
        <AiIcon />
      </div>
      <div className={styles.placeholderMainText}>{props.mainText}</div>
      <div className={styles.placeholderHelperText}>{props.helperText}</div>
    </div>
  );
};
